var _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon, _path24, _polygon2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 844.67004,
    height: 631.96836,
    viewBox: "0 0 844.67004 631.96836",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1017.12685,174.89055H478.64524a2.14191,2.14191,0,0,1,0-4.28277h538.48161a2.14191,2.14191,0,0,1,0,4.28277Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.6354,
    cy: 12.82923,
    rx: 12.54956,
    ry: 12.82923,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.98842,
    cy: 12.82923,
    rx: 12.54956,
    ry: 12.82923,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.34145,
    cy: 12.82923,
    rx: 12.54956,
    ry: 12.82923,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M991.02113,137.18825H960.22952a2.3311,2.3311,0,0,0,0,4.661h30.79161a2.33071,2.33071,0,0,0,0-4.661Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M991.02113,145.94073H960.22952a2.331,2.331,0,0,0,0,4.66085h30.79161a2.33064,2.33064,0,0,0,0-4.66085Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M991.02113,154.69308H960.22952a2.3311,2.3311,0,0,0,0,4.661h30.79161a2.33071,2.33071,0,0,0,0-4.661Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M395.81191,260.9292H613.06267a.99993.99993,0,0,1,.99993.99993V388.25259a.99993.99993,0,0,1-.99993.99993H395.81191a0,0,0,0,1,0,0V260.9292A0,0,0,0,1,395.81191,260.9292Z",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M790.47242,523.95113,573.19073,395.914l.57231-1.938L791.04479,522.01319a1.01035,1.01035,0,0,1,.68279,1.25512h0A1.01035,1.01035,0,0,1,790.47242,523.95113Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M573.763,524.23732l-.57231-1.938L790.47242,394.26224a1.01034,1.01034,0,0,1,1.25516.68281h0a1.01035,1.01035,0,0,1-.68279,1.25512Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 416.51074,
    y: 134.55957,
    width: 176.60851,
    height: 9.46095,
    rx: 4.73047,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 394.04098,
    y: 164.09089,
    width: 221.54803,
    height: 9.46095,
    rx: 4.73047,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 394.04098,
    y: 193.6222,
    width: 221.54803,
    height: 9.46095,
    rx: 4.73047,
    fill: "#3dafb5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M989.6399,427.32992a86.003,86.003,0,0,1-57.55946,81.12423c-.73195.26255-1.46387.50121-2.20374.732a85.92925,85.92925,0,1,1,59.7632-81.85619Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M788.48526,338.99666a7.23887,7.23887,0,0,0,7.86185,7.83583l10.5815,23.44745,7.14473-11.29828-11.14374-20.534a7.27811,7.27811,0,0,0-14.44434.549Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M892.76335,427.29806a17.26328,17.26328,0,0,0-.58871-2.04457,18.11851,18.11851,0,0,0-8.64784-10.01624c-.09547-.0557-.1989-.11139-.29436-.15913l-48.33883-24.52743-4.28813-8.3614L813.278,348.43322l-4.24836,1.265-10.04009,2.98339-.2307.06366,16.64331,56.00808,3.81872,2.92769L862.476,444.76083l1.40817,1.082a18.26818,18.26818,0,0,0,23.79553-1.40016,17.37376,17.37376,0,0,0,1.79-2.00485A18.20155,18.20155,0,0,0,892.76335,427.29806Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#3dafb5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M919.63772,488.81153l-.25459-9.22859-.73191-26.763c2.64921-17.1286,4.5268-19.03-8.25-30.74083a3.58453,3.58453,0,0,1-2.34694-1.70248c-1.16155-2.37084,1.6309-6.39642-.77969-12.59389l-19.02206,1.08993-4.72568,6.36456-19.01414,25.61736a43.11873,43.11873,0,0,0-2.03666,3.90622c-8.13866,17.67759,2.89589,27.07327,3.75512,28.68825l5.26666,16.58766,2.90385,16.0864.93877,2.23554,2.64921.97063a86.26906,86.26906,0,0,0,51.88709-.1432A136.63294,136.63294,0,0,0,919.63772,488.81153Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#3dafb5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M956.4803,553.87085a7.23885,7.23885,0,0,0-4.8726-9.97329l-2.346-25.61733-10.44206,8.34637,3.82873,23.047a7.2781,7.2781,0,0,0,13.832,4.1972Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#ffb6b6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M920.09917,428.26072a18.17564,18.17564,0,0,0-12.04494-7.88407,17.90382,17.90382,0,0,0-3.19821-.28645,18.17858,18.17858,0,0,0-10.048,3.03112,17.44133,17.44133,0,0,0-2.63333,2.13217,18.22443,18.22443,0,0,0-.40575,25.77644l27.61424,28.553,10.064,10.40606,2.63333,18.46515,4.04943,28.40982,4.42336.19092,10.46973.46145.23866.008,1.7423-39.81034.81145-18.56061Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#3dafb5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M882.36332,364.11332c-6.72517,13.25533-2.332,28.6093,10.14766,36.6834,13.49489,8.73094,31.01613,6.81921,36.6834-10.14767,6.31109-18.89434,1.12636-26.99987-10.14766-36.6834C905.83481,342.61762,889.62975,349.79122,882.36332,364.11332Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M915.46848,393.642a21.29279,21.29279,0,0,1-33.88135-25.79891l.18478-.24269a21.29279,21.29279,0,0,1,33.6913,26.0376Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#ffb6b6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M875.846,361.96713a29.09357,29.09357,0,0,0,12.28146,6.959,12.72307,12.72307,0,0,1,3.23667-2.6823,13.61138,13.61138,0,0,0-1.18781,3.84324c2.053,4.26054,10.43769,7.3227,18.45143,10.45507l10.61429-18.73242L905.19276,353.849C893.90375,346.04425,880.614,349.37534,875.846,361.96713Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M927.24863,353.98913a6.54357,6.54357,0,0,1,6.18632.90339,13.78811,13.78811,0,0,1,4.03834,4.91189,35.2184,35.2184,0,0,1,3.66155,9.97939c.606,3.02144.50342,6.67438-2.20752,8.25114-2.262,1.31569-5.49636.48727-7.57535-1.26857a16.829,16.829,0,0,1-4.26449-6.63353c-1.0143-2.40956-1.97384-4.90794-3.77664-6.90906l1.873.87441a16.36875,16.36875,0,0,1-.81528-5.57554A5.39979,5.39979,0,0,1,927.24863,353.98913Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M902.94889,356.44424l15.07266,8.54057A17.66311,17.66311,0,0,1,924.68142,389.06l0,0a27.41644,27.41644,0,0,1-35.05591,11.50446l13.77316-12.15863-18.68419,9.51979-3.98925-2.26041C900.7636,392.02176,904.62908,376.30324,902.94889,356.44424Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M931.42209,371.455c2.53666,2.95329,6.50835,4.10126,10.09117,5.63811a42.45218,42.45218,0,0,1,24.66315,31.01408c.99055,5.527.861,11.24836,2.42558,16.63648,1.55532,5.38813,5.4066,10.67443,10.93362,11.60949,3.74018.6388,7.48963-.80544,11.00764-2.23119q2.9024-1.16646,5.80474-2.34223-3.02733-7.59618-6.0454-15.1923a76.98992,76.98992,0,0,0,11.21135,13.11853q10.40127-4.19386,20.82108-8.38774c-17.09017.06481-14.17389-16.52539-17.99743-33.17114-2.10157-9.14685-19.99711-15.34041-23.50591-24.04289a26.62244,26.62244,0,0,0-48.28936-2.42557C929.03353,363.07661,928.9317,368.53882,931.42209,371.455Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M434.97467,531.70837a9.355,9.355,0,0,1,2.79088-13.97134l-4.8806-46.37147,12.49439-4.50346,5.39408,55.11848a9.34183,9.34183,0,0,1-15.79875,9.72779Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#ffb6b6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M428.29316,361.69735s20.283,9.89638,20.34884,21.53078,1.746,22.15724.15872,26.65888,4.03357,37.22288,1.4024,40.46327,2.78964,4.89873-.05885,10.44425-4.10975,6.58943-3.06587,7.85068,2.57726,25.301,2.57726,25.301l-16.71342,2.09-17.77936-77.59161Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M331.83656,536.41893a9.35493,9.35493,0,0,0-.55309-14.23661l12.131-45.02191-11.628-6.41714-14.01721,53.57854a9.34182,9.34182,0,0,0,14.06733,12.09712Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#ffb6b6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M365.24039,369.588s-21.58966,6.57454-23.4891,18.053-5.21772,21.60479-4.36008,26.30039-9.85211,36.1213-7.76476,39.736-3.52714,4.39761-1.58865,10.3229,3.01937,7.155,1.78969,8.23588-6.53428,24.5782-6.53428,24.5782l16.17484,4.69907,29.791-73.81777Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "270.487 603.829 284.887 603.828 291.738 548.284 270.485 548.285 270.487 603.829",
    fill: "#ffb6b6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M467.3443,739.141v-9.76243l-3.78573.23128-15.41045.91294-3.56655.2191-2.72665,32.6956-.14606,1.75285h10.22491l.32869-1.74067,1.485-7.91217,3.83439,7.91217.83991,1.74067h27.10835a6.12512,6.12512,0,0,0,6.08628-6.09847C492.76064,753.748,470.217,742.19628,467.3443,739.141Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.78 588.154 114.305 595.26 147.674 550.331 129.189 539.844 101.78 588.154",
    fill: "#ffb6b6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M295.504,732.76253l4.80818-8.48432-3.38394-1.66764-13.86458-6.80443-3.21357-1.58242-15.7878,23.11571-3.71269,5.42892,4.19955,2.38585,4.68649,2.6658,6.354-7.49827-.706,10.69966,22.14192,12.57429h.01219l1.42424.80336a6.09621,6.09621,0,0,0,8.30163-2.30063C310.39111,758.00844,296.49,736.8525,295.504,732.76253Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M376.68864,465.19093c-31.9161,1.14673-43.13263,131.27439-33.38629,133.63455l-45.48327,84.76471L362.55792,712.61l42.56693-147.80184,7.09449,54.39108L402.76,705.51548l41.84613,10.11978,28.94394-2.06743c-7.521-102.88745-26.29919-211.40192-41.86145-253.37689Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M362.03731,474.31468l-.21.79c20.4,11.35,34.33046,8.92168,56.63045,2.05169l16.27957-3.4217c3.55319-4.63348.65738-9.16543-3.27957-13.5783l9.75956-80.27166a18.83094,18.83094,0,0,0-20.23-18.66l-14.66-10.86-20.87.72-13.96,15.42-8.34,2.98-6.48,2.31c-1.31,1.18-2.74,2.54-4.11,4.04l10.25,61,4.36,18.24C361.33278,461.73854,358.11271,468.24321,362.03731,474.31468Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M243.639,755.11572a50.70216,50.70216,0,0,1-36.89941-23.3125c-5.23584-8.49121-7.9375-18.5752-10.55029-28.32715-.76075-2.83789-1.54688-5.77246-2.3794-8.60156a16.181,16.181,0,0,1,5.34326-17.32618,15.90842,15.90842,0,0,1,17.7334-1.83007l.61133.32422,1.07129,24.07812c1.5874-3.22559,5.0708-10.51269,7.83056-17.78906l.23145-.60938.52881.38184a81.386,81.386,0,0,1,14.95459,13.89648,83.8819,83.8819,0,0,1,17.7539,68.25586l-.1333.71387Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#f2f2f2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M177.665,764.79418a1.18647,1.18647,0,0,0,1.19006,1.19h842.29a1.19,1.19,0,0,0,0-2.38H178.855A1.18651,1.18651,0,0,0,177.665,764.79418Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#ccc"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "bd49c871-c00b-42cd-b6c0-926f55b3555f-20",
    "data-name": "Path 9",
    d: "M425.57336,336.67112l.02054-.00538a4.257,4.257,0,0,0,3.02621-5.20438l-6.0633-22.97a31.748,31.748,0,0,0-5.58395-11.34083,32.26,32.26,0,0,0-20.73745-12.14808,31.76651,31.76651,0,0,0-12.71555.69628c-16.97018,4.45108-21.71,10.06368-22.66782,38.78662s6.07254,23.005,6.07254,23.005a4.26393,4.26393,0,0,0,.75147,1.5255,4.33371,4.33371,0,0,0,2.79139,1.62982,4.27782,4.27782,0,0,0,1.70007-.09359c21.19215-2.18152,42.65456-4.168,53.40927-13.88185Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "feb2d559-022c-4dbd-b662-f2ca25a42d04-21",
    "data-name": "Ellipse 1",
    d: "M375.747,312.421a23.41773,23.41773,0,0,0,34.79138,25.70429,23.145,23.145,0,0,0,10.61437-14.33744,23.41774,23.41774,0,0,0-34.77121-25.7005,23.14494,23.14494,0,0,0-10.63432,14.3345Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#ffb6b6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "eb6fbc8f-da17-4bf8-a5d6-541e9e148243-22",
    "data-name": "Path 10",
    d: "M430.3356,308.43767a25.1145,25.1145,0,0,0-4.41647-8.96918c-2.92413-7.28981-7.511-13.1818-16.39832-9.6047a25.12609,25.12609,0,0,0-9.993.53778l-4.60349,1.19052q-.07757.02-.155.04049a25.07214,25.07214,0,0,0-17.82392,30.65179l.12144.46008,9.73611-2.528.87058-10.14017,3.11356,9.10766,5.0292-1.3038.43834-5.11563,1.57088,4.59166c9.53577,3.7048,20.58757.02933,32.62752-8.45643Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "f8380615-0651-4923-afc2-c19b051f9812-23",
    "data-name": "Path 13",
    d: "M407.99819,340.5361a4.189,4.189,0,0,1,.41623,2.26865,4.28429,4.28429,0,0,1-.27362,1.16334,4.33386,4.33386,0,0,1-.48178.90053,4.24979,4.24979,0,0,1-2.41383,1.67532q-.09156.02327-.184.0431t-.186.03541q-.09422.01666-.18893.028t-.19118.01942l-3.61751.28381-7.43574-8.90264,2.456,9.30407-16.43981,1.31733-10.42207-39.48256,26.34338-6.81864-.451.92712a18.71585,18.71585,0,0,0-1.74669,9.98612,30.50841,30.50841,0,0,0,2.8381,9.98386,55.01662,55.01662,0,0,0,5.38811,9.05966,81.086,81.086,0,0,0,5.91035,7.22626A4.27847,4.27847,0,0,1,407.99819,340.5361Z",
    transform: "translate(-177.66498 -134.01582)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.134487d8e99269c72e9bb99679e0ddc7.svg";
export { ForwardRef as ReactComponent };